'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default from 'react';
import NotificationProvider from './context/index.js';
import NotificationMain from './components/NotificationMain/index.js';

function openNotification() {
    if (typeof window === 'undefined') {
        return;
    }
    var event = new CustomEvent('VNW_OPEN_NOTIFICATION');
    window.dispatchEvent(event);
}
var Notifications = function (props) {
    return (React__default.createElement(NotificationProvider, __assign({}, props),
        React__default.createElement(NotificationMain, null)));
};

export { Notifications as default, openNotification };
//# sourceMappingURL=index.js.map
